// extracted by extract-css-chunks-webpack-plugin
module.exports = {"group_summary":"GroupSummary__group_summary--DNmg_","summary":"GroupSummary__summary--3-HM9","meta":"GroupSummary__meta--76osy","closed":"GroupSummary__closed--347Ou"};